export const endpoints = {
  packages: (): string => '/api/tenants/packages/?package=all',
  tenants: (id?: number | string | undefined | null): string =>
    `/api/management/tenants/${id ? `${id}/` : ''}`,
  license: (
    id?: number | string | undefined | null,
    licenseId?: string | number
  ): string =>
    `/api/management/tenants/${id ? `${id}/` : ''}licenses/${licenseId ? `${licenseId}/` : ''}`,
}

export default endpoints
